import {useSyncExternalStore} from 'react';
import {
    getExpressOrderStoreIdFromCookie,
    subscribeExpressOrderStoreIdCookie,
} from 'modules/express-order/helpers/expressOrderStoreCookie';

export const useExpressOrderStoreId = (ssrFallback?: string): string => {
    return useSyncExternalStore(
        subscribeExpressOrderStoreIdCookie,
        () => getExpressOrderStoreIdFromCookie() || ssrFallback || '',
        () => ssrFallback || '',
    );
};
